import { object, boolean, array, number } from "yup";

import { fetchData } from "@utils/api";
import { APIMethods, ApiResponse } from "@typeDefinitions";

export interface FetchLogRocketSettingsResponse {
  all: boolean;
  trial: boolean;
  clinicIds: number[];
  userIds: number[];
}

const logRocketSettingsSchema = object({
  all: boolean().required(),
  trial: boolean().required(),
  clinicIds: array().of(number().required()).required(),
  userIds: array().of(number().required()).required(),
});

const fetchLogRocketSettingsResponseSchema = object({
  data: logRocketSettingsSchema.required(),
});

export const fetchLogRocketSettings = async (): Promise<
  ApiResponse<FetchLogRocketSettingsResponse>
> => {
  const response = await fetchData(
    "/system-settings/logrocket",
    APIMethods.GET,
  );
  return await fetchLogRocketSettingsResponseSchema.validate(response);
};
